const { navigate, withPrefix } = require('gatsby');

const isExternalLink = (lnk = '') =>
  ['http://', 'https://', 'ftp://'].some(protocol => lnk.startsWith(protocol));


const normalizeString = (s) => {
  if (s) {
    return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  return null;
};

const createLayoutSlice = (websiteId, portalId, websiteRoot, createSlice, reporter, locale, theme) => {
  const themeToUse = theme === null ? 'SciencesPo' : theme;
  const themeHash = {
    'SciencesPo': require.resolve('../components/layout/EcoWebLayout.js'),
    'Care': require.resolve('../components/layout/CareLayout.js')
  };
  createSlice({
    id: `internal-page-layout--${portalId}`,
    context: {
      mock: portalId === 0,
      locale: locale,
      websiteRoot: websiteRoot,
      websiteId: websiteId
    },
    component: themeHash[themeToUse]
  });
  reporter.verbose(`creation slice ${themeToUse}-layout--${portalId}`);
};

const arrayWithEnouthItemsCarrousel = (items, nbmin) => {
  let result = [...items];
  while (result.length < nbmin) {
    result = [
      ...result, ...items.map(
        (item) => ({
          ...item,
          id: `${item.id}-copy-${Math.floor(result.length / items.length)}`
        })
      )
    ];
  }
  return (result);
};

const typeToUrl = {
  'HAL': 'https://hal.science/search/index/?q=*&authIdPerson_i={{identifier}}',
  'ORCID': 'https://orcid.org/{{identifier}}',
  'GOOGLE_SCHOLAR': 'https://scholar.google.com/citations?user={{identifier}}',
  'RESEARCH_GATE': 'https://www.researchgate.net/profile/{{identifier}}',
  'X': 'https://twitter.com/{{identifier}}',
  'MASTODON': '{{identifier}}',
  'BLUESKY': 'https://bsky.app/profile/{{identifier}}',
  'INSTAGRAM': 'https://www.instagram.com/{{identifier}}',
  'LINKEDIN': 'https://www.linkedin.com/in/{{identifier}}',
  'WEBSITE': '{{identifier}}',
  'BIBLIOGRAPHY': '{{identifier}}',
  'YOUTUBE': 'https://www.youtube.com/{{identifier}}',
  'TIKTOK': 'https://www.tiktok.com/@{{identifier}}',
  'CV': '{{identifier}}',
  'REPEC': '{{identifier}}',
  'IDREF': 'https://www.idref.fr/{{identifier}}'
};

const searcherGenerateUrl = (object) => {
  const {type, identifier} = object;
  if (typeToUrl[type]) {
    return typeToUrl[type].replace('{{identifier}}', identifier);
  }
};

const folderObjecLocaletMap = {
  'event-en': 'events',
  'event-fr': 'evenements',
  'news_item-en': 'news',
  'news_item-fr': 'actualites',
};

const getObjectUrl = (siteURL, slug, type, locale) => {
  if (slug) {
    const folderKey = `${type}-${locale}`;
    const uri = `/${siteURL}/${folderObjecLocaletMap[folderKey]}/${slug}`;
    return uri.replace(/\/\/+/g, '/');
  }
  return null;
};

const followLink = (url, target) => {
  if (isExternalLink(url) || target === '_blank') {
    typeof target !== 'undefined'
        && window !== 'undefined'
        && window.open(toExternalUrl(url), target);
  } else {
    navigate(url);
  }
};

const removeStyleTags = (richText) => {
  // Supprime toutes les balises <style>
  richText = richText.replace(/<style.*?<\/style>/g, '');

  // Supprime les attributs de style des autres balises
  richText = richText.replace(/ style=".*?"/g, '');

  return richText;
};

const dompurifyConfig = {
  ADD_TAGS: ['iframe', 'script', 'more'], //or ALLOWED_TAGS
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'target', 'async'], //or //or ALLOWED_ATR
};


const isServer = () => {
  return ! (typeof window != 'undefined' && window.document);
};


const getHostname = (env) => {
  if (env ) {
    try {
      return (new URL(env)).hostname;
    } catch( err ){
      console.error(err);
    }
  }
  return null;
};

const config = {
  cmsDomain:  getHostname(process.env.IMAGE_BASE_URL) || 'eco-web.sciences-po.fr',
  targetDomain: getHostname(process.env.CONFIG_WEBSITE_BASE_URL) || 'www.sciencespo.fr'
};


const convertExternalEcoSysLinks = (html) => {
  if (html && typeof html === 'string' && config.cmsDomain && config.targetDomain) {
    const regEx = new RegExp(config.cmsDomain, 'g');
    return html.replace(regEx, config.targetDomain);
  }
  return html;
};

const toExternalUrl = (uri, useWithGatsbyLink = false) => {
  if (!uri) return uri;
  if (isExternalLink(uri)) {
    if (config.cmsDomain && config.targetDomain) {
      const replacement = uri.replace(config.cmsDomain, config.targetDomain);
      if (uri !== replacement) {
        return replacement;
      }
    }
    return uri;
  }
  // relative uri. needs website prefix
  if (useWithGatsbyLink) {
    return uri;
  }
  // make sure we don't fuck up the links by calling this method twice ...
  const wp = withPrefix('/');
  if (uri.startsWith(wp)) {
    return uri;
  }
  return withPrefix(uri);
};


const specialTypeFolders = {
  'news-fr': 'actualites',
  'news-en': 'news',
  'event-fr': 'evenements',
  'event-en': 'events'
};

const createUrl = (slug, locale, websiteUrl, type) => {
  const stk = [websiteUrl];
  if ([''].includes(websiteUrl)) {
    stk.splice(0, 0, '/');
  }
  stk.push(specialTypeFolders[`${type}-${locale}`], slug);
  return stk.join('/').replace(/\/\/+/g, '/');
};

const createNewsUrl = (slug, locale, siteURL) => {
  return createUrl(slug, locale, siteURL, 'news');
};

const createEventUrl = (slug, locale, siteURL) => {
  return createUrl(slug, locale, siteURL, 'event');
};

const setupi18n = (locale, i18n) => {
  if (locale !== i18n.language) {
    i18n.changeLanguage(locale);
  }
};


module.exports = {
  isExternalLink,
  followLink,
  removeStyleTags,
  dompurifyConfig,
  arrayWithEnouthItemsCarrousel,
  searcherGenerateUrl,
  toExternalUrl,
  createNewsUrl,
  createEventUrl,
  convertExternalEcoSysLinks,
  isServer,
  getObjectUrl,
  normalizeString,
  createLayoutSlice,
  setupi18n
};
